import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import UsersFilters from "../../../components/accessManagement/molecules/UsersFilters";
import UsersTable from "../../../components/accessManagement/organisms/UsersTable";
import AddUserDrawer from "../../../components/accessManagement/organisms/AddUserDrawer";
import AssignRoleModal from "../../../components/accessManagement/organisms/AssignRoleModal";
import { useAccessManagementUsers } from "./useAccessManagementUsers";
import "../AccessManagement.css";
import "./Users.css";

const AccessManagementUsersPage: React.FC = () => {
  const { functions, values, loading, error, setters } = useAccessManagementUsers();

  return (
    <div className="page-content">
      <Container fluid className="feature-management-page">
        {/* Breadcrumbs */}
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Access Management" },
              { label: "Users", active: true },
            ]}
          />
        </div>

        {/* Header + Filters (organism: header + molecule: UsersFilters) */}
        <div style={{ padding: "0 15px", marginBottom: "24px" }}>
          <Row className="align-items-center justify-content-between g-3">
            <Col xs="12" md="auto">
              <h2 className="mb-0">Users</h2>
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                {`${values.totalCount} Active Users`}
              </p>
            </Col>
            <Col xs="12" md={8}>
              <UsersFilters
                statusValue={values.statusFilter}
                onStatusChange={setters.setStatusFilter}
                searchValue={values.search}
                onSearchChange={setters.setSearch}
                onAddUserClick={() => {
                  // Only users with manage-level permissions should see this button at all
                  functions.handleAddUser();
                }}
              />
            </Col>
          </Row>
        </div>

        {/* Users table organism */}
        <div style={{ padding: "0 15px" }}>
          <UsersTable
            users={values.users as any}
            loading={loading.isPageLoading}
            error={error}
            page={values.page}
            totalPages={values.totalPages}
            pageSize={values.pageSize}
            totalCount={values.totalCount}
            onPageChange={setters.setPage}
            onPageSizeChange={(size) => {
              setters.setPageSize(size);
              setters.setPage(1);
            }}
            onViewUser={functions.handleViewUser}
            onEditUser={functions.handleEditUser}
            onAssignRole={functions.handleAssignRole}
            onToggleStatus={functions.handleToggleStatus}
          />
        </div>

        <AssignRoleModal
          show={values.assignRoleModalOpen}
          onHide={functions.handleCloseAssignRoleModal}
          user={values.assignRoleUser}
          onSuccess={functions.refetchUsers}
        />

        <AddUserDrawer
          show={values.drawerOpen}
          onHide={functions.handleCloseDrawer}
          mode={values.drawerMode}
          initialData={values.drawerUser ?? undefined}
          onSuccess={functions.refetchUsers}
        />
      </Container>
    </div>
  );
};

export default AccessManagementUsersPage;

